<template>
  <ValidationProvider v-slot="{ errors }" name="FCP Status" rules="required">
    <BaseSelect
      v-model="modelValue"
      v-bind="$attrs"
      :options="options"
      :disabled="isDisabled || $attrs.disabled" 
      :state="errors.length > 0 ? false : null"
      size="sm"
    >
      <template v-slot:label>
        FCP? <span class="text-danger">*</span>
      </template>

      <template v-slot:first>
        <b-form-select-option :value="undefined" disabled
          >Select</b-form-select-option
        >
      </template>
    </BaseSelect>

    <div v-if="!!errors.length" class="invalid-feedback d-block">
      {{ errors[0] }}
    </div>
  </ValidationProvider>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'
import { ValidationProvider } from 'vee-validate'

import { KEEP_AS_IS_OPTION, YES_NO_OPTIONS  } from '@constants'
import { useCurrentUser, useUserCompany } from '@composables'

import { BaseSelect } from '@components/base'

export default defineComponent({
  name: 'BDXEditFormFCPStatus',
  components: {
    ValidationProvider,
    BaseSelect
  },
  props: {
    value: [String, Boolean],
    useKeepAsIsOption: Boolean,
  },
  emits: ['input'],
  setup(props, { emit }) {
    const { isSuperUser } = useCurrentUser()
    const { isRoleName: isCompanyRoleName } = useUserCompany()

    const modelValue = computed({
      get: () => props.value,
      set: (newValue) => emit('input', newValue)
    })

    const isDisabled = computed(() => {
      if (isSuperUser.value) return false

      return !isCompanyRoleName('TPA') && !isCompanyRoleName('Underwriter')
    })

    let options =  YES_NO_OPTIONS;
    if (props.useKeepAsIsOption) {
      options = [KEEP_AS_IS_OPTION, ...options];
    }

    return {
      options,

      modelValue,
      isDisabled
    }
  }
})
</script>
